import { render } from "./UserListPage.vue?vue&type=template&id=140a63c6&scoped=true&ts=true"
import script from "./UserListPage.vue?vue&type=script&lang=ts"
export * from "./UserListPage.vue?vue&type=script&lang=ts"

import "./UserListPage.vue?vue&type=style&index=0&id=140a63c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140a63c6"]])

export default __exports__